import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { getFilterValues, getAppliedFilter } from '../sbSharedRefineMenuHelpers';

// components
import { SbSharedRefineMenuRadioSelect } from './SbSharedRefineMenuRadioSelect';
import { SbSharedRefineMenuTypeaheadContainer } from '../SbSharedRefineMenuTypeahead/SbSharedRefineMenuTypeaheadContainer';

const SbSharedRefineMenuRadioSelectSearchComponent = props => {
    const { viewer, values, itemSearch, filterName, totalCount } = props;
    const { appliedFilters, displayUriRef } = itemSearch;

    const appliedFilter = getAppliedFilter(appliedFilters, filterName);
    const appliedFilterValues = getFilterValues(appliedFilters, filterName);
    const canBeDismissed = appliedFilter ? appliedFilter.canBeDismissed : true;

    return (
        <SbSharedRefineMenuTypeaheadContainer
            viewer={viewer}
            filterName={filterName}
            itemSearch={itemSearch}
            availableFilterValues={values}
            appliedFilterValues={appliedFilterValues}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuRadioSelect
                    filterName={filterName}
                    totalCount={totalCount}
                    valuesToShow={valuesToShow}
                    displayUriRef={displayUriRef}
                    canBeDismissed={canBeDismissed}
                    appliedFilterValues={appliedFilterValues}
                />
            )}
        </SbSharedRefineMenuTypeaheadContainer>
    );
};

SbSharedRefineMenuRadioSelectSearchComponent.propTypes = {
    totalCount: PropTypes.number,
    values: PropTypes.array.isRequired,
    viewer: PropTypes.object.isRequired,
    filterName: PropTypes.string.isRequired,
    itemSearch: PropTypes.object.isRequired,
};

export const SbSharedRefineMenuRadioSelectSearch = createFragmentContainer(
    SbSharedRefineMenuRadioSelectSearchComponent,
    {
        viewer: graphql`
            fragment SbSharedRefineMenuRadioSelectSearch_viewer on Viewer {
                ...SbSharedRefineMenuTypeaheadContainer_viewer
            }
        `,
        itemSearch: graphql`
            fragment SbSharedRefineMenuRadioSelectSearch_itemSearch on ItemSearchQueryConnection {
                displayUriRef
                ...SbSharedRefineMenuTypeaheadContainer_itemSearch
                appliedFilters {
                    name
                    localizedFilterName
                    canBeDismissed
                    values {
                        urlLabel
                        linkReference
                        count
                        displayName
                    }
                }
            }
        `,
    }
);
